import { ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthenticationService } from 'app/auth/service';
import { environment } from 'environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthenticationService,
    private toastrService: ToastrService,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const isApi = request.url.startsWith(`${environment.apiUrl}/`);
    if (
      isApi &&
      !request.headers.has('Authorization') &&
      this.authService.token
    ) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${this.authService.token}` },
      });
    }
    return next.handle(request).pipe(
      catchError((response: HttpErrorResponse) => {
        const error = response.error;
        const detail = error?.details?.message || error?.details;
        const isSessionRequest =
          isApi &&
          (request.url.includes('/private/') ||
            request.url === `${environment.apiUrl}/public/auth/refresh-token`);
        const rejected =
          (response.status === 401 && detail === 'invalid_session_token') ||
          (response.status === 403 &&
            ['JsonWebTokenError', 'TokenExpiredError'].includes(error?.cause));
        if (isSessionRequest && rejected) {
          const token = request.url.endsWith('/refresh-token')
            ? request.body?.token
            : request.headers.get('Authorization')?.replace(/^Bearer\s+/i, '');
          if (token && this.authService.token === token) {
            this.toastrService.warning(
              'La sesión venció o fue cerrada. Inicia sesión nuevamente.',
            );
            this.authService.clearSession(token);
          }
        }
        // Retain the legacy error body contract, including OTP wait metadata.
        return throwError(error || response);
      }),
    );
  }
}
